import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { selectorLanguage } from '@app/core/nav/lang-switcher/lang.reducer';
import { observeTypes } from '../interfaces/response-interfaces';

@Injectable()
export class HeadersSetterHelper {
  private lang = 'bg';

  constructor(private store: Store<any>) {
    this.store
      .select(selectorLanguage)
      .subscribe(lang => this.lang = lang);
  }

  loginOptions(observeType) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,

      }),
      observe: observeType
    };
  }

  options(observeType) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'Content-Language': this.lang
      }),
      withCredentials: true,
      observe: observeType
    };
  }

  optionsWithCustomHeaders(observeType, customHeaders: any) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        ...customHeaders,
        'Accept-Language': this.lang,
        'Content-Language': this.lang
      }),
      withCredentials: true,
      observe: observeType     
    };
  }

  optionsWithCustomHeadersAndResponseType(observeType, customHeaders: any, responseType?) {
    return {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        ...customHeaders
      }),
      reportProgress: true,
      responseType,
      withCredentials: true,
      observe: observeType
    };
  }

  addEmployeeOptions(observeType, params) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'Content-Language': this.lang
      }),
      withCredentials: true,
      observe: observeType,
      params
    };
  }

  postOptions(observeType) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'Content-Language': this.lang,
      }),
      withCredentials: true,
      observe: observeType
    };
  }

  fileOptions(observeType, responseType?) {
    return {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
      }),
      reportProgress: true,
      responseType,
      withCredentials: true,
      observe: observeType
    };
  }

  historyOptions(observeType, params) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,

      }),
      withCredentials: true,
      observe: observeType,
      params
    };
  }
  

  paramsOptions(observeType, params) {
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'Content-Language': this.lang,
      }),
      withCredentials: true,
      observe: observeType,
      params
    };
  }

  otpOptions(observeType,requestId:string){
    return {
      headers: new HttpHeaders({
        'Accept-Language': this.lang,
        'BTrust-Request-ID':requestId
      }),
      withCredentials:false,
      observe: observeType     
    }
  }

  getActivationData(observeType){
    return {
      headers: new HttpHeaders({
        'Cache-control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'Content-Language': this.lang,
      }),
      withCredentials: false,
      observe: observeType
    };
  }

  bTrustRequestId(observeType,requestId:string){
    return {
      headers: new HttpHeaders({
        'Accept-Language': this.lang,
        'BTrust-Request-ID':requestId
      }),
      withCredentials:false,
      observe: observeType     
    }
  }
  fileOptionsActivation(observeType, responseType?) {
    return {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
      }),
      reportProgress: true,
      responseType,
      withCredentials: false,
      observe: observeType
    };
  }
  fileOptionsExcel(observe: 'response', params?: HttpParams) {
    return {
      observe,
      responseType: 'blob' as 'json',
      params,
      headers: new HttpHeaders({
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    };
  }
  downloadExcelFileReport(): HttpHeaders {
    return new HttpHeaders({     
    'Content-Disposition': 'attachment' 
    });
  }
  BTrustDocumentOptions(observeType, params, btrustRequestId, responseType?) {
    return {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': 'true',
        'Accept-Language': this.lang,
        'BTrust-Request-ID':btrustRequestId
      }),
      params:params,
      reportProgress: true,
      responseType,
      withCredentials: false,
      observe: observeType
    };
  }

}
